import { useFetchUser, useLogoutUser } from '___queries'

export const useUser = (publicFlow: boolean = false) => {
  const user = useFetchUser(publicFlow)
  const logout = useLogoutUser()
  return Object.assign({}, user, { logout })
}

export default useUser
